/**
 * Common icon mixin props
 */
export default {
    props: {
        /**
         * Checks if icon is 
         * in registered sate or not
         */
        openDelay: {
            type: Number,
            required: true
        },
        placement: {
            type: String,
            required: true
        },
        effect: {
            type: String,
            required: true
        },
        hasNoEmailOrPhone: {
            type: Boolean,
            default: false
        },
        hasMobileApp: {
            type: Boolean,
            default: false
        },
        hasVerifiedEmail: {
            type: Boolean,
            default: false
        },
        hasVerifiedPhone: {
            type: Boolean,
            default: false
        },
        tooltipText:  {
            type: String,
            required: true
        }
    }
}
